import AdminKeysSecretsPanel from "../components/keys-secrets/AdminKeysSecretsPanel";

const AdminKeysSecretsPage = () => {
  return <AdminKeysSecretsPanel />;
};

export default AdminKeysSecretsPage;
